import { useEffect, useState } from "react";
import {
  useParams
} from "react-router-dom";
import "./index.css"
import ImageGalleryCard from "./imageGalleryCard";
import { emptyProperty, FullProperty } from "../models/fullProperty";
import { useScreenSize } from "../hooks/useScreenSize";
import { Helmet } from "react-helmet";
import { StringsService } from "../services/strings/strings";
import { restaurantService } from "../services/firebase/restaurantManagementService";
import CartPillButton from "./cartPillButton";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, Skeleton, Tab, Tabs, Typography } from "@mui/material";
import DescriptionCard from "./longDescriptionCard";
import OverviewCard from "./overviewCard";
import Lottie from "lottie-react";
import { logEvent } from "../firebase";
import { MetricsNames } from "../services/firebase/metricsService";
import CommentsSection from "./ratings/comments";
import { CommentType } from "../models/commentType";
import { CommentsClient } from "../services/functions/commentsClient";
import { useSignedInUserState } from "../hooks/useAuthState";
import AsyncString from "../shared/asyncString";
import { BaseItem, Bundle, bundleViewData, ComboVariant, decorateBundle, FullMenuPageData, MenuCategory, MenuItem } from "../models/fullMenuPageData";
import { cheapestPriceOfComboVariant, getLowestPriceOfMenuItem, getPriceOfMenuCart, MenuCart, MenuCartItem } from "../models/fullMenuCart";
import { ShowAsSoldOut } from "../shared/showAsSoldOut";
import { ExpandMore } from "@mui/icons-material";
import { useTemporaryMenuCartProviderCart } from "../hooks/contexts/TemporaryMenuCartContext";
import { formatMoney } from "../services/strings/formatters";
import BundleCustomizationModal from "./menuItemCustomization/bundleCustomizationModal";
import { ItemCustomizationModal } from "./menuItemCustomization/itemCustomizationModal";
import { menuService } from "../services/firebase/menuService";
import { useSwipeable } from "react-swipeable";

const BUNDLE_ID = "Bundle"

interface IBodyProps {
  menuData: FullMenuPageData;
  isLoading: boolean;
}

interface IMenuComponent {
  menuData: FullMenuPageData;
  onSelectItem: (baseItem: BaseItem | null, menuItem: MenuItem | null, comboVariant: ComboVariant | null, bundle: bundleViewData | null) => void
}


const isComboVariantSoldOut = (comboVariant: ComboVariant, menuData: FullMenuPageData): boolean => {
  for (const cv of comboVariant.itemVariantIds) {
    const comboVariantItem = menuData.baseItems.find(bi => bi.id === cv)
    if (!comboVariantItem || comboVariantItem.isSoldOut) {
      return true
    }
  }
  return false
}

const isWholeMenuSoldOut = (menuItem: MenuItem, menuData: FullMenuPageData): boolean => {
  if (menuItem.isCombo && !!menuItem.comboVariants) {
    return !menuItem.comboVariants.map(cv => isComboVariantSoldOut(cv, menuData)).includes(false)
  } else {
    const baseItem = menuData.baseItems.find(bi => bi.id === menuItem.baseItemId);
    if (!baseItem || baseItem.isSoldOut) {
      return true
    }
  }
  return false
}

const isBundleSoldOut = (bundle: Bundle, menuData: FullMenuPageData) => {
  const found = bundle.items.map(bi => {
    let menuItem: MenuItem | undefined = undefined;
    menuData.menu.categories.forEach(cat => {
      cat.items.forEach(ci => {
        if (ci.id === bi.menuItemId) {
          menuItem = ci
        }
      })
    })
    if (!menuItem || isWholeMenuSoldOut(menuItem, menuData)) {
      return true
    }
    return false
  })
  console.log(found)
  return found.includes(true)
}

function RenderCategory({ menuData, onSelectItem, category }: IMenuComponent & { category: MenuCategory }) {

  return <>
    {category.items.map(item => {
      const baseItem = menuData.baseItems.find(bi => bi.id === item.baseItemId);
      const lowestPrice = getLowestPriceOfMenuItem(item, menuData);
      if (item.isCombo && item.comboVariants && baseItem) {
        return <ShowAsSoldOut
          isSoldOut={isWholeMenuSoldOut(item, menuData)}
        >
          <Accordion
            sx={{
              width: "100%",
              maxWidth: {
                xs: 360,
                sm: 600,
              },
              border: "1px solid #ccc",
              borderRadius: 1,
              backgroundColor: "#fff",
              p: 2,
              mb: 2,
              cursor: "pointer",
              boxSizing: "border-box", // include padding in width
            }}
            defaultExpanded={false}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box
                key={item.id}
                sx={{ width: "100%" }}
              >
                <Typography variant="h6">{baseItem?.name}</Typography>
                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    {!item.isOnSale && <Typography variant="body2">Starting at {formatMoney(lowestPrice / 100)}</Typography>}
                    {item.isOnSale && item.salePrice && <Typography variant="body2" color="error">On Sale: {formatMoney(item.salePrice / 100)}</Typography>}
                  </Box>
                  {item.imageUrl && <img src={item.imageUrl} alt="Preview" style={{ width: '128px' }} />}
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignItems: "start"
            }}>
              {
                item.comboVariants.map(cv =>
                  <ShowAsSoldOut
                    isSoldOut={isComboVariantSoldOut(cv, menuData)}
                    onClick={() => onSelectItem(baseItem, item, cv, null)}
                  >
                    <Button
                    >{cv.name} - {formatMoney(cheapestPriceOfComboVariant(menuData, cv) / 100)}</Button>
                  </ShowAsSoldOut>
                )
              }
            </AccordionDetails>

          </Accordion>
        </ShowAsSoldOut>
      }

      // if ()

      return <ShowAsSoldOut
        isSoldOut={isWholeMenuSoldOut(item, menuData)}
        onClick={() => baseItem && onSelectItem(baseItem, item, null, null)}
      >
        <Box
          key={item.id}
          sx={{
            width: "100%",
            maxWidth: {
              xs: 360,
              sm: 600,
            },
            border: "1px solid #ccc",
            borderRadius: 1,
            backgroundColor: "#fff",
            p: 2,
            mb: 2,
            cursor: "pointer",
            boxSizing: "border-box", // include padding in width
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="h6">{baseItem?.name}</Typography>
              {!item.isOnSale && <Typography variant="body2">Starting at {formatMoney(lowestPrice / 100)}</Typography>}
              {item.isOnSale && item.salePrice && <Typography variant="body2" color="error">On Sale: {formatMoney(item.salePrice / 100)}</Typography>}
            </Box>
            {item.imageUrl ?
              <img src={item.imageUrl} alt="Preview" style={{ width: '128px' }} /> :
              (baseItem != undefined && baseItem.imageUrl && <img src={baseItem.imageUrl} alt="Preview" style={{ width: '128px' }} />)
            }
          </Box>
        </Box>
      </ShowAsSoldOut>
    })}
  </>
}

function RenderBundle({ menuData, onSelectItem }: IMenuComponent) {
  return <>{menuData.menu.bundles.map(bundle => {
    let minPrice: number = 0
    const decoratedBundle = decorateBundle(bundle, menuData)
    decoratedBundle.items.forEach(item => {
      let minOverridePrice: number | null = null
      if (item.noVariantPriceOverride) {
        minPrice += item.noVariantPriceOverride
      }
      item.variantPriceOverrides.forEach(priceOverride => {
        if (minOverridePrice == null || minOverridePrice > priceOverride.price) {
          minOverridePrice = priceOverride.price
        }
      })
      if (minOverridePrice) {
        minPrice += minOverridePrice * item.quantity;
      }
    })

    return (
      <ShowAsSoldOut
        isSoldOut={isBundleSoldOut(bundle, menuData)}
        onClick={() => onSelectItem(null, null, null, decoratedBundle)}
      >
        <Box
          key={bundle.id}
          sx={{
            width: "100%",
            maxWidth: {
              xs: 360,
              sm: 600,
            },
            border: "1px solid #ccc",
            borderRadius: 1,
            backgroundColor: "#fff",
            p: 2,
            mb: 2,
            cursor: "pointer",
            boxSizing: "border-box", // include padding in width
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="h6">{bundle.name}</Typography>
              {<Typography variant="body2">Starting at {formatMoney(minPrice / 100)}</Typography>}
            </Box>
            {bundle.imageUrl && <img src={bundle.imageUrl} alt="Preview" style={{ width: '128px' }} />}
          </Box>
        </Box >
      </ShowAsSoldOut>
    );
  })}</>
}

function FullMenuListingBody(props: IBodyProps & { onSelectItem: (baseItem: BaseItem | null, menuItem: MenuItem | null, comboVariant: ComboVariant | null, bundle: bundleViewData | null) => void; }) {
  const screenSize = useScreenSize();
  return screenSize.width > 800 ? <MenuComponent {...props} /> : <MenuComponent {...props} />;
}


function MenuComponent({ menuData, onSelectItem }: IMenuComponent) {
  const categories = menuData.menu.categories || [];
  // if bundles exist then append to categories here
  if (menuData.menu.bundles.length > 0 && !categories.find(c => c.id === BUNDLE_ID)) {
    categories.push({
      id: BUNDLE_ID,
      name: "Deals",
      items: []
    })
  }

  const [activeIndex, setActiveIndex] = useState(0);

  const handlers = useSwipeable({
    onSwipedLeft: () => setActiveIndex(i => Math.min(i + 1, categories.length - 1)),
    onSwipedRight: () => setActiveIndex(i => Math.max(i - 1, 0)),
    trackMouse: true, // allows swiping with mouse too
  });

  if (categories.length === 0) return <Typography>Loading menu...</Typography>;

  return (
    <Box {...handlers}>
      {/* Tabs */}
      <Tabs
        value={activeIndex}
        onChange={(_, newIndex) => setActiveIndex(newIndex)}
        variant="scrollable"
        scrollButtons="auto"
        TabIndicatorProps={{
          style: { backgroundColor: "#162C1F" },
        }}
      >
        {categories.map((cat, i) => (
          <Tab
            key={cat.id}
            label={cat.name}
            sx={{
              color: "rgba(0,0,0,0.2)",
              "&.Mui-selected": {
                color: "#162C1F",
              },
              "&.Mui-selected .MuiTab-wrapper": {
                fontWeight: "bold",
              },
            }}
          />
        ))}
      </Tabs>

      {/* Swipeable content */}
      <Box sx={{ overflow: "hidden", width: "100%", marginTop: 2 }}>
        <Box
          sx={{
            display: "flex",
            width: `${categories.length * 100}%`,
            transform: `translateX(-${activeIndex * 100}%)`,
            transition: "transform 0.3s ease",
          }}
        >
          {categories.map(category => (
            <Box
              key={category.id}
              sx={{
                flex: "0 0 100%",
                boxSizing: "border-box",
                px: 2, // padding left & right equally
                py: 2, // keep vertical padding too
                overflow: "hidden",
                justifyContent: "center", // centers the inner content
              }}
            >
              {
                categories[activeIndex].id === BUNDLE_ID ?
                  <RenderBundle menuData={menuData} onSelectItem={onSelectItem} />
                  :
                  <RenderCategory category={category} menuData={menuData} onSelectItem={onSelectItem} />
              }
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}


function ListingDetailsPage() {
  const { id } = useParams();
  let user = useSignedInUserState()

  const [restaurantName, setRestaurantName] = useState<string>("");
  const [shortSummary, setShortSummary] = useState<string>("");
  const [thumbnail, setThumbnail] = useState<string>("");
  const [listing, SetListing] = useState<FullProperty>(emptyProperty);
  const [comments, setComments] = useState<CommentType[]>([]);
  const [rating, setRating] = useState<number>(0);
  const [numRatings, setNumRatings] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [menuData, setMenuData] = useState<FullMenuPageData>({ baseItems: [], menu: { categories: [], bundles: [] } });
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [isBundleModalOpen, setIsBundleModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<{ baseItem: BaseItem | null; menuItem: MenuItem | null; comboVariant: ComboVariant | null; bundle: bundleViewData | null } | null>(null);
  const { updateTemporaryMenuCart, loading, temporaryMenuCart } = useTemporaryMenuCartProviderCart();

  useEffect(() => {

    const fetchMenu = async () => {
      if (id) {
        setIsLoading(true);
        try {
          const menu = await menuService.fetchFullMenuCached(id);
          setMenuData(menu);
        } catch (err) {
          setError((err as Error).message);
        } finally {
          setIsLoading(false);
        }
      }
    };

    const fetchStrings = async () => {
      if (id) {
        setIsLoading(true)
        const name = await StringsService.getStringById(`${id}-restaurant-name`);
        const summary = await StringsService.getStringById(`${id}-short-restaurant-summary`);
        const image = await StringsService.getStringById(`${id}-thumbnail`);
        const { comments: _comments, rating: _rating, numRatings: _numRatings } = await CommentsClient.getComments(id)
        setRating(_rating)
        setComments(_comments)
        setNumRatings(_numRatings)
        setRestaurantName(name);
        setShortSummary(summary);
        setThumbnail(image);
        SetListing(await restaurantService.fetchRestaurantById(id))
        setIsLoading(false)
      }
    };
    logEvent(MetricsNames.VIEW_ITEM);
    fetchStrings();
    fetchMenu();
  }, [id]);

  const addCommentCall = async (data: { parentId?: string; text: string; rating: number }) => {
    setIsLoading(true)
    if (id && user.profile) {
      if (!user.profile.name) {
        setError("Please Set Your name in your profile");
      } else {
        try {

          await CommentsClient.addComment({
            restaurantId: id,
            authorId: user.profile.id,
            author: user.profile.name,
            text: data.text,
            rating: data.rating,
            parentId: (data.parentId ? data.parentId : undefined),
          });
          const { comments: _comments, rating: _rating, numRatings: _numRatings } = await CommentsClient.getComments(id)
          setRating(_rating)
          setComments(_comments)
          setNumRatings(_numRatings)
        } catch (error) {
          setError((error as Error).message)
        }
      }
    }
    setIsLoading(false)
  }

  const handleSelectItem = (baseItem: BaseItem | null, menuItem: MenuItem | null, comboVariant: ComboVariant | null, bundle: bundleViewData | null) => {
    setSelectedItem({ baseItem, menuItem, comboVariant, bundle });
    if (bundle == null) {
      setIsItemModalOpen(true);
    } else {
      setIsBundleModalOpen(true);
    }
  };

  const handleAddToCart = (cartItems: MenuCartItem[]) => {
    if (!id) {
      console.log("restaurant ID is null")
      return
    }
    const fullCartItems = temporaryMenuCart != null ? temporaryMenuCart.items : [];
    cartItems.forEach((ci => { fullCartItems.push(ci) }))
    let grandTotalBeforeFees = getPriceOfMenuCart(fullCartItems, menuData);
    const newMenuCart: MenuCart = {
      grandTotalBeforeFees: grandTotalBeforeFees,
      items: fullCartItems,
      restaurantId: id
    }
    console.log("publishing cart", newMenuCart)
    // lets put the menu object into a temporary firestore collection for tracking
    // This will be faster than triggering a firestore function
    // and we will do validation once we get to the summery page
    updateTemporaryMenuCart(newMenuCart)
  };

  return (
    <div className="patlite" style={{ width: "100vw", minHeight: "100vh" }}>
      <Helmet>
        <title>{`Eco Eats | ${restaurantName} Menu`}</title>
        <meta
          name="description"
          content={`Explore the delicious plant-based menu from ${restaurantName} on Eco Eats. Order conscious meals and support local.`}
        />
        <meta property="og:title" content={`Eco Eats | ${restaurantName}`} />
        <meta
          property="og:description"
          content={`Discover the plant-based menu from ${restaurantName} with Eco Eats - South Africa's conscious food marketplace.`}
        />
        <meta name="twitter:image" content={thumbnail} />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="p8" />
      <div className="ListingDetailPage">
        <ImageGalleryCard id={id ?? ""} />
        <div className="p8" />
        <FullMenuListingBody menuData={menuData} isLoading={(isLoading || loading)} onSelectItem={handleSelectItem} />
        <CartPillButton />
        <div className="p8" />
        <CommentsSection
          comments={comments}
          onSubmitComment={data => addCommentCall(data)}
          hideRatingComment={false}
        />
      </div>
      <div className="p8" />


      {selectedItem && selectedItem.baseItem && selectedItem.menuItem && (
        <ItemCustomizationModal
          isOpen={isItemModalOpen}
          onClose={() => setIsItemModalOpen(false)}
          onAddToCart={handleAddToCart}
          baseItem={selectedItem.baseItem}
          menuItem={selectedItem.menuItem}
          comboVariant={selectedItem.comboVariant}
          menuData={menuData}
        />
      )}

      {selectedItem && selectedItem.bundle && (
        <BundleCustomizationModal
          isOpen={isBundleModalOpen}
          onClose={() => setIsBundleModalOpen(false)}
          onAddToCart={handleAddToCart}
          bundle={selectedItem.bundle}
          menuData={menuData}
        />
      )}

      {/* Error Modal */}
      <Dialog open={!!error} onClose={() => setError(null)}>
        <DialogTitle>
          <AsyncString stringId="error" />
        </DialogTitle>
        <DialogContent>
          <Typography>{error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setError(null)} color="primary">
            <AsyncString stringId="close" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ListingDetailsPage;
